import { take, call, put, takeLatest } from 'redux-saga/effects';
import { ACTIONS_TYPES } from "../utils/constants";
import { loginUser } from '../utils/requests';
import { loginSuccess, loginFailed } from '../actions/loginPage';

export function* loginWatcherSaga() {
  yield takeLatest(ACTIONS_TYPES.LOGIN_REQUEST, loginRequestWatcher);
}

function* loginRequestWatcher(action) {
    try {
      const { payload } = action;
      const response = yield call(loginUser, payload);

      const expiresInTimestamp = new Date().getTime() + (response.data.expiresIn * 1000);

      response.data.expiresIn = expiresInTimestamp;

      localStorage.setItem('auth', JSON.stringify(response.data));

      yield put(loginSuccess(response.data));

    } catch(error) {
      let errorPayload = {};
      if (error.response) {
        errorPayload = error.response.data;
      }
      yield put(loginFailed(errorPayload));
    }
}